<template>
    <!-- la URL que envia el email debe ser http://localhost:8080/clients/welcome?request=REQUESTID&token=TOKENREQUEST&user=client -->
    <CContainer class="d-flex content-center bg-white">
        <div class="">
            <CRow class="">
                <CCol sm="12" class="">
                    <img class="img-fluid" :src="this.imgInfoBuddyHappy" alt="imgInfoBuddyHappy">
                </CCol>
            </CRow>
            <CRow>
                <CCol sm="12">
                    <p class="h5">Oficialmente eres parte de nuestro <b>#TeamInfoguia</b></p>
                </CCol>
            </CRow>
            <br>
            <CRow>
                <CCol sm="12" class="borderInfoFriend">
                    <h3>¡Gracias por actualizar tus datos!</h3>
                    <p class="h5">En <b>72 horas</b> podrás ver los cambios en tu publicación</p>
                </CCol>
            </CRow>
            <br>
            <CRow>
                <CCol sm="12">
                    <p class="h5">Recuerda que mientras mayor sea tu presencia en Internet, mayores serán tus
                        probabilidades de éxito...</p>
                </CCol>
            </CRow>
            <br>
            <CRow class="bg-dark">
                <CCol sm="3">
                    <img class="img-fluid" :src="this.imgStars" alt="imgStars">
                </CCol>
                <CCol sm="6">
                    <p class="h3" style="margin-top: 4%;color:white">¡Estamos felices de que sigas formando parte de
                        nosotros!</p>
                </CCol>
                <CCol sm="3">
                    <img class="img-fluid" :src="this.imgStars" alt="imgStars">
                </CCol>
            </CRow>
            <br>
        </div>
    </CContainer>
</template>
<script>
    export default {
        /**Componente usado para dar el agradecimiento al cliente por llenar el formulario y actualizar sus datos */
        name: 'thankYouMessage',
        title: 'Gracias por Actualizar sus datos!! | Infoguia',
        //freeSet,
        beforeCreate: function () {},
        created() {},
        data() {
            return {
                imgInfoBuddyHappy: process.env.VUE_APP_THANKYOUMESSAGE_INFOBUDDYHAPPY,
                imgStars: process.env.VUE_APP_THANKYOUMESSAGE_STARS,
            }
        },
        mounted() {
            this.redirectInfoguia();
        },
        methods: {
            redirectInfoguia() {
                setTimeout(function () {
                    window.location.href = "https://infoguia.com/";
                }, 20000);
            }
        }
    }
</script>